import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _MetricsSkeleton;
import cn from "clsx";
import { Col, Container, Row } from "@crehana/ui";
import { useStudyPlan } from "../hooks";
import { ActionMetrics, ActivityMetrics, EditStudyPlan, MetricsSkeleton, ProgressMetrics } from "./components";
import { useActionMetrics } from "./hooks/useActionMetrics";
import { useLearningPlanTranslation } from "./hooks/useLearningPlanTranslation";
import AlertView from "./ui/AlertView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var LearningPlan = function LearningPlan(_ref) {
  var _Col;
  var isDark = _ref.isDark,
    className = _ref.className,
    fromHomeUser = _ref.fromHomeUser,
    onActionClick = _ref.onActionClick,
    onEditStudyPlan = _ref.onEditStudyPlan;
  var _useLearningPlanTrans = useLearningPlanTranslation(),
    t = _useLearningPlanTrans.t;
  var _useActionMetrics = useActionMetrics({
      onActionClick: onActionClick
    }),
    actionMetricProps = _useActionMetrics.actionMetricProps,
    loadingMetrics = _useActionMetrics.loading;
  var _useStudyPlan = useStudyPlan(),
    loading = _useStudyPlan.loading,
    error = _useStudyPlan.error,
    plan = _useStudyPlan.plan;
  var shouldRenderSetStudyPlan = !(plan !== null && plan !== void 0 && plan.progress) && ((plan === null || plan === void 0 ? void 0 : plan.currentDayIndex) || 0) >= 2;
  var hasStudyPlan = !!(plan !== null && plan !== void 0 && plan.target.minutes);
  var metrics = [actionMetricProps.completedCourses, actionMetricProps.completedTracks, actionMetricProps.completedProjects, actionMetricProps.completedAdditionalCourses];
  var renderContent = function renderContent() {
    if (loading || loadingMetrics) {
      return _MetricsSkeleton || (_MetricsSkeleton = /*#__PURE__*/_jsx(MetricsSkeleton, {
        isAnimated: true,
        "data-testid": "study-plan-skeleton"
      }));
    }
    if (error) {
      return /*#__PURE__*/_jsx(AlertView, {
        title: t('STUDY_PLAN_ERROR'),
        isDark: isDark,
        onEditStudyPlan: onEditStudyPlan,
        metrics: metrics,
        "data-testid": "study-plan-error-view"
      });
    }
    if (!hasStudyPlan) {
      return /*#__PURE__*/_jsx(AlertView, {
        isDark: isDark,
        title: t('EMPTY_VIEW_TITLE'),
        description: t('EMPTY_VIEW_DESC'),
        onEditStudyPlan: onEditStudyPlan,
        metrics: metrics,
        "data-testid": "study-plan-empty-view"
      });
    }
    return /*#__PURE__*/_jsxs(Row, {
      gutter: fromHomeUser ? 24 : {
        xs: 24,
        lg: 16
      },
      "data-testid": "learning-plan-metrics",
      children: [/*#__PURE__*/_jsx(Col, {
        xs: 12,
        sm: 12,
        lg: 6,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex md:justify-between h-full",
          children: [/*#__PURE__*/_jsx(ActionMetrics, {
            title: t('LEARNING_PLAN_ACTIONS_TITLE'),
            isDark: isDark,
            metrics: metrics
          }), /*#__PURE__*/_jsx("div", {
            className: cn('tw-hidden lg:tw-block tw-border-r tw-border-solid tw-w-1 tw-h-14.4 tw-my-auto tw-ml-1.6 tw-self-center', isDark ? 'border-gray-lighter-dark-mode' : 'border-gray-light'),
            role: "separator",
            "aria-orientation": "vertical"
          })]
        })
      }), shouldRenderSetStudyPlan ? _Col || (_Col = /*#__PURE__*/_jsx(Col, {
        xs: 12,
        children: /*#__PURE__*/_jsx(EditStudyPlan, {
          isDark: isDark,
          onEditStudyPlan: onEditStudyPlan
        })
      })) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Col, {
          xs: 12,
          sm: 6,
          lg: 3,
          children: /*#__PURE__*/_jsx(ActivityMetrics, _objectSpread(_objectSpread({}, plan), {}, {
            onEditStudyPlan: onEditStudyPlan,
            isDark: isDark,
            isCompact: true
          }))
        }), /*#__PURE__*/_jsx(Col, {
          xs: 12,
          sm: 6,
          lg: 3,
          children: /*#__PURE__*/_jsx(ProgressMetrics, _objectSpread(_objectSpread({}, plan), {}, {
            isDark: isDark
          }))
        })]
      })]
    });
  };
  return /*#__PURE__*/_jsx(Container, {
    type: fromHomeUser ? 'default' : 'dashboard',
    className: cn('tw-p-1.6 tw-rounded-0.4', isDark ? 'bg-base-lighter-dark-mode' : 'tw-bg-neutral-light-100', className),
    children: renderContent()
  });
};
export default LearningPlan;